import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import {
  ApiResponseModel,
  ApiVisa,
  BaseApiTemplateService,
  Core2Config,
  Pagination,
  PagingResponseModel,
} from "../../shared";
import { GenericDocContainerModel } from "../../../../../../models/aggregates/generic_doc";
import { Observable } from "rxjs";
import { BaseGenDocTypeService } from "./base-generic-doc-hdr.service";
import { RecurringBaseGenDocTypeService } from "./recurring-base-generic-doc.service";
import {
  RecurringEventViewCriteriaDtoModel,
  RecurringGenericDocSearchCriteriaDtoModel,
} from "../../../data-transfer-objects";

@Injectable({
  providedIn: "root",
})
export class RecurringSaleInvoiceService extends RecurringBaseGenDocTypeService {
  constructor(http: HttpClient) {
    super(http, "internal-sales-invoices");
  }

  public getEventViewByCriteria(
    dtoObject: RecurringEventViewCriteriaDtoModel,
    visa: ApiVisa
  ): Observable<ApiResponseModel<any>> {
    let url;
    if (this.endpoint_path_event_view_url && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path_event_view_url + "/query";
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      url,
      dtoObject,
      this.getHttpHeaderJson(visa)
    );
  }

  public getEventView(visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let url;
    if (this.endpoint_path_event_view_url && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path_event_view_url;
    }
    return this.httpClient.get<ApiResponseModel<any>>(
      url,
      this.getHttpHeaderJson(visa)
    );
  }

  public getRecurringBySnapshotCustomQuery(
    dtoObject: RecurringGenericDocSearchCriteriaDtoModel,
    visa: ApiVisa
  ): Observable<ApiResponseModel<any>> {
    let url;
    if (this.apiUrl && visa.api_domain_url) {
      url =
        visa.api_domain_url +
        Core2Config.TENANT_DOMAIN_URL_PREFIX +
        Core2Config.ERP_PREFIX +
        Core2Config.GENERIC_DOC_PREFIX +
        Core2Config.RECURRING_PREFIX +
        "/" +
        this.docType +
        "/custom/backoffice-ep/query/snapshot";
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      url,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  deleteInvoice(
    guid: string,
    deleteType: string,
    visa: ApiVisa
  ): Observable<ApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      console.log(
        "this.endpoint_path && visa.api_domain_url: ",
        visa.api_domain_url + this.endpoint_path
      );
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.delete<ApiResponseModel<any>>(
      this.apiUrl + "/" + guid + "?recurring_delete_type=" + deleteType,
      this.getHttpHeader(visa)
    );
  }

  getSalesInvoiceByLogin(pagination: Pagination, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const UrlByCriteria =
      this.apiUrl + "/login-entity-ep/query?" + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<GenericDocContainerModel>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }

  getLinesByCriteria(
    pagination: Pagination,
    visa: ApiVisa
  ): Observable<PagingResponseModel<GenericDocContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = `${visa.api_domain_url}${this.endpoint_path}/type`;
    }
    const UrlByCriteria =
      this.apiUrl + "/query?" + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<GenericDocContainerModel>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }

  getLinesByCriteriaPromise(
    pagination: Pagination,
    visa: ApiVisa
  ): Promise<PagingResponseModel<GenericDocContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = `${visa.api_domain_url}${this.endpoint_path}/type`;
    }
    const UrlByCriteria =
      this.apiUrl + "/query?" + pagination.getQueryKeyValues();
    return this.httpClient
      .get<PagingResponseModel<GenericDocContainerModel>>(
        UrlByCriteria,
        this.getHttpHeader(visa)
      )
      .toPromise();
  }

  public postWithAttachments(
    dtoObject: FormData,
    visa: ApiVisa
  ): Observable<ApiResponseModel<any>> {
    let url;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      url,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  public deleteAttachment(
    extensionGuid: string,
    visa: ApiVisa
  ): Observable<ApiResponseModel<any>> {
    let url;
    if (this.attachmentUrl && visa.api_domain_url) {
      url = visa.api_domain_url + this.attachmentUrl;
    }
    return this.httpClient.delete<ApiResponseModel<any>>(
      url + "/" + extensionGuid,
      this.getHttpHeader(visa)
    );
  }

  public getAttachmentsByCriteria(
    pagination: Pagination,
    visa: ApiVisa,
    criteria?: any
  ): Observable<PagingResponseModel<any>> {
    // console.log('get by criteria bsae-api');
    let url;
    if (this.attachmentUrl && visa.api_domain_url) {
      url = visa.api_domain_url + this.attachmentUrl;
    }
    const UrlByCriteria = url + "/query?" + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<any>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }

  public printJasperPdf(
    guid: string,
    printServiceClassName: string,
    printableFormatGuid: string,
    apiVisa: ApiVisa,
    customParam?: string
  ): Observable<Blob> {
    let params;
    if (customParam) {
      params = new HttpParams()
        .set("printServiceClassName", printServiceClassName)
        .set("printableFormatHdrGuid", printableFormatGuid)
        .set("customParam", customParam);
    } else {
      params = new HttpParams()
        .set("printServiceClassName", printServiceClassName)
        .set("printableFormatHdrGuid", printableFormatGuid);
    }
    return this.httpClient.get<Blob>(
      this.apiUrl + "/print-jasper-pdf/" + guid,
      this.getHttpHeaderBlob(apiVisa, params)
    );
  }
}
